import { UpdatePdfDocuments } from './updatePdfDocuments';
import { Box, Typography } from '@mui/material';
import { usePdfPreview } from '../hooks/usePdfPreview';
import OpenPDFDialog from './openPDFDialog';
import { useState } from 'react';
import Iconify from './Iconify';
import '../css/pdfDocuments.css';

const PdfDocuments = ({ documents, hasUpdatePermission, handleUploadDocuments, handleDawnloadAllDocument, handleDawnloadDocument,
    handleRemoveAllDocument, handleRemoveDocument, openDeletePDF, setOpenDeletePDF, pdfId, setPdfId }) => {

    const [openEdit, setOpenEdit] = useState(false);
    const { dialogProps, openFromUrl } = usePdfPreview();

    const handleOpenDocument = (url, name) => {
        openFromUrl(url, {
            fileName: name || 'document.pdf',
            title: name || 'Document PDF',
        });
    };

    return (
        <Box className='pdfDoc_main_box'>
            <Box className='pdfDoc_title_icon_box'>
                <Typography className='pdfDoc_title'>Documents</Typography>
                <Box className='pdfDoc_icons_box'>
                    {documents?.length > 0 &&
                        <Iconify className='pdfDoc_actions_icon' icon={"material-symbols:download-rounded"} onClick={handleDawnloadAllDocument} />
                    }
                    {hasUpdatePermission &&
                        <Iconify className='pdfDoc_actions_icon' icon={"ic:outline-edit"} onClick={() => setOpenEdit(true)} />
                    }
                </Box>
            </Box>

            {documents?.length === 0 &&
                <Typography className='pdfDoc_dashed_typography'>Il n’existe aucun document dans cette section</Typography>
            }
            <Box className='pdfDoc_documents_box'>
                {documents?.map((doc, index) => (
                    <Box
                        className='pdfDoc_document_item'
                        key={index}
                    >
                        <Iconify className='pdfDoc_pdf_icon' icon={"bxs:file-pdf"} />
                        <Typography className='pdfDoc_doc_name'>{doc?.name}</Typography>
                        <Typography className='pdfDoc_doc_size'>{(doc?.size / (1024 * 1024))?.toFixed(2)} MB</Typography>
                        <Iconify
                            className='pdfDoc_upload_one_icon'
                            icon={"tabler:arrows-maximize"}
                            onClick={() => handleOpenDocument(doc.key || doc.display_url, doc?.name)}
                        />
                        <Iconify className='pdfDoc_delete_icon' icon={"material-symbols:download-rounded"} onClick={() => handleDawnloadDocument(doc)} />
                    </Box>
                ))}
            </Box>

            {openEdit &&
                <UpdatePdfDocuments
                    openEdit={openEdit}
                    setOpenEdit={setOpenEdit}
                    documents={documents}
                    openDeletePDF={openDeletePDF}
                    setOpenDeletePDF={setOpenDeletePDF}
                    handleUploadDocuments={handleUploadDocuments}
                    handleRemoveAllDocument={handleRemoveAllDocument}
                    handleRemoveDocument={handleRemoveDocument}
                    pdfId={pdfId}
                    setPdfId={setPdfId}
                />
            }

            <OpenPDFDialog {...dialogProps} />
        </Box>
    );
};

export default PdfDocuments;
